import { useCheckVerificationsComplete } from 'hooks/useCheckVerificationsComplete';
import { useGetRisingStarBonus } from 'services/hooks/risingStarBonus';

import Card from 'components/card/Card';
import withErrorBoundary from 'components/provider/withErrorBoundary';
import Flex from 'components/util/Flex';

import BonusHistory from './BonusHistory';
import { useRisingStarCopy } from './copy';

/**
 * 별지기 화면의 샛별 달성 보너스 적립 내역 (studio#2524, 10/6 기획 답변 D).
 *
 * 25일 산정 후 말일 지급 전에 별지기로 승급해도 보너스는 지급된다. 별지기에게는 샛별 블록이 보이지 않으므로
 * 받은 보너스는 여기 적립 내역으로만 보여준다. 어떤 달을 내려줄지는 서버가 정하고, 내역이 없으면 그리지 않는다.
 * 노출 여부는 부모가 `StargazerGate` 로 정한다.
 */
function StargazerBonusHistory() {
  const COPY = useRisingStarCopy();
  const { data, isError } = useGetRisingStarBonus();
  const { isBankAccountVerificationCompleted, isConvertibleToBubble } = useCheckVerificationsComplete();

  // 샛별 시절 보너스 이력이 없는 별지기는 history 가 null 로 온다
  if (isError || !data?.history?.length) return null;

  const isBlur = !(isBankAccountVerificationCompleted || isConvertibleToBubble);

  return (
    <Flex isExpanded>
      <Card isExpanded>
        <Card.Header>
          <Card.Title>{COPY.stargazerHistoryTitle}</Card.Title>
        </Card.Header>
        <Card.Body>
          <BonusHistory history={data.history} isBlur={isBlur} showTitle={false} />
        </Card.Body>
      </Card>
    </Flex>
  );
}

export default withErrorBoundary(StargazerBonusHistory, () => null);
